import { GoogleLogin } from '@react-oauth/google';
import { useState } from 'react';
import './style.scss';
import { Button, Input, Spin, message } from 'antd';
import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { SignInApi } from '../../../apis/SignIn';
import MetaModelLogo from '../../../Images/sidebar/Logo_MetaModel.svg';
import useAuthContext from '../../../hooks/useAuthContext';
import { LoadingOutlined } from '@ant-design/icons';
import verifyIcon from '../../../Images/verify_icon.svg';
import { useCookies } from 'react-cookie';
const SignUp = () => {
  let navigate = useNavigate();
  const [formData, setFormData] = useState();
  const [isShowOtp, setIsShowOtp] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [verifiedOtpToken, setVerifiedToken] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [errorPassword, setErrorPassword] = useState('');
  const [isButtoDisable, setIsButtonDisable] = useState(true);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;

  const [loading, setLoading] = useState(false);
  const { dispatcher } = useAuthContext();
  const [searchParams] = useSearchParams();

  const leadId = localStorage.getItem('leadId');


  const googleLogin = useGoogleLogin({
    flow: 'implicit',
    onSuccess: async (credentialResponse) => {
      const response = await SignInApi.getCredsGoogleLogin(credentialResponse);
      console.log(response);
      let obj = {
        email: response.data.email,
        name: response.data.name,
        distributorId:
          sessionStorage.getItem('mm:dbId') || '663b39b3ab4ec46c6ebcf259',
        accessToken: credentialResponse.access_token,
        firstName: response.data.given_name,
        lastName: response.data.family_name,
      };
      if(leadId !==null && leadId !=='null'){
        obj.leadId = leadId;
      }
      
      const userResponse = await SignInApi.userGoogleLogin(obj);
      if (userResponse.status === 200) {
        let user = {
          userEmail: obj.email,
          userName: obj.name,
          userToken: userResponse.data.token,
        };
        
        dispatcher({
          type: 'LOGIN',
          payload: user,
        });
        localStorage.setItem('mm:user', JSON.stringify(user));
        localStorage.setItem('metamodel_token', userResponse.data.token);
        navigate('/');
      }
    },
  });
  const handleChange = (e) => {
    if (e.target.name == 'email') {
      setIsOtpVerified(false);
      setIsShowOtp(false);
      setIsShowPassword(false);
      setErrorMsg('');
    }

    setIsButtonDisable(false);

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    console.log(formData);
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    if (!passwordRegex.test(newPassword)) {
      setErrorPassword(
        'At least 1 uppercase, 1 lowercase, 1 number, 1 special character is required with minimum 8 length long'
      );
      setIsButtonDisable(true);
    } else {
      setErrorPassword(''); // Clear the error message
      setIsButtonDisable(false);
    }

    setPassword(newPassword);
  };

  const handleFirstNameChange = (e) => {
    const newName = e.target.value;

    setFirstName(newName);
  }

  const handleLastNameChange = (e) => {
    const newName = e.target.value;

    setLastName(newName);
  }

  function validateName(name) {
    return name.trim() !== '' && /^[a-zA-Z]+$/.test(name.trim());
  }
  const generateSignUpOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!validateName(firstName)) {
      message.error('Please enter a valid first name without spaces, numbers, or special characters.');
      return;
    }
    if (!validateName(lastName)) {
      message.error('Please enter a valid last name without spaces, numbers, or special characters.');
      return;
    }
    if (!formData?.email.trim()) {
      message.error('Please enter an email');
      return;
    }
    if (!emailRegex.test(formData?.email)) {
      setErrorMsg('Please enter correct email');
      return;
    }
    try {
      const result = await SignInApi.generateSignUpOtp(formData);

      if (result?.status == 200) {
        setIsShowOtp(true);
        setLoading(false);
        setIsButtonDisable(true);
      }
      if (result?.response?.status == 400) {
        setLoading(false);
        message.error(
          result.response.data.message || 'Please try again later.'
        );
      }
    } catch (err) {
      setLoading(false);
      let error = JSON.parse(err.response.data);
      message.error(error.error || 'Please try again later.');
    }
  };
  const verifyOtp = async (e) => {
    e.preventDefault();
    if (!formData?.otp.trim()) {
      message.error('Please enter otp');
      return;
    }
    setLoading(true);
    try {
      formData.distributorId = '663b39b3ab4ec46c6ebcf259';
      const result = await SignInApi.verifySignUpOtp(formData);
      if (result?.status == 200) {
        if (result?.data?.otpVerified) {
          setIsOtpVerified(true);
          setVerifiedToken(result.data.token);
          setTimeout(() => {
            setIsShowOtp(false);
            setIsShowPassword(true);
            setLoading(false);
            setIsButtonDisable(true);
          }, 2000);
        } else {
          message.error(result?.data?.reason);
          setLoading(false);
        }
        console.log(result);
      }
      if (result?.response?.status == 400) {
        message.error(
          result.response.data.message || 'Please try again later.'
        );
      }
    } catch (err) {
      message.error(err.response.data || 'Please try again later.');
    }
  };
  const registerUser = async (e) => {
    e.preventDefault();

    if (!password.trim()) {
      message.error('Please enter password');
      return;
    }
    setLoading(true);
    try {
      let payload = {
        password: password,
        token: verifiedOtpToken,
        firstName: firstName,
        lastName: lastName,
       
      };

      if(leadId !==null && leadId !=='null'){
       payload.leadId = leadId;
      }
      
      const result = await SignInApi.registerUser(payload);
      if (result?.status == 200) {
        let user = {
          userEmail: formData?.email,
          userName: formData?.email,

          userToken: result.data.token,
        };
        dispatcher({
          type: 'LOGIN',
          payload: user,
        });
        localStorage.setItem('mm:user', JSON.stringify(user));
        localStorage.setItem('metamodel_token', result.data.token);
        navigate('/');
        setLoading(false);
      }
      if (result?.response?.status == 400) {
        message.error(
          result.response.data.message || 'Please try again later.'
        );
      }
    } catch (err) {
      console.log(err);
      message.error(err.response.data || 'Please try again later.');
    }
  };
  const getMetaModelLogo = () => {
    return (
      <div className="logo_line">
        <img
          src={MetaModelLogo}
          alt="metaModelLogo"
          onClick={() => navigate('/')}
        />
      </div>
    );
  };
  const getGoogleLogin = () => {
    return (
      <div className="google_login_line">
        <Button className="google_login_btn" onClick={googleLogin}>
          {/* <img
            src="./../../Images/google_logo.svg"
            alt="googleIcon"
            className="google_icon"
          /> */}
          <p> Continue with Google</p>
        </Button>
      </div>
    );
  };
  const getUserRegistrationForm = () => {
    return (
      <>
        <div className="field_wrapper">
          <div className="user_firstName">
            <Input
              type="text"
              id="firstName"
              name="firstName"
              value={formData?.firstName}
              placeholder='First Name'
              required
              className="firstName_input"
              onChange={handleFirstNameChange}
            />
          </div>
          <div className="user_firstName">
            <Input
              type="text"
              id="lastName"
              name="lastName"
              value={formData?.lastName}
              placeholder='Last Name'
              required
              className="firstName_input"
              onChange={handleLastNameChange}
            />
          </div>
        </div>
        <div className="user_email">
          <Input
            type="email"
            id="email"
            name="email"
            value={formData?.email}
            placeholder="Your email"
            required
            className="email_input"
            onChange={handleChange}
            onPressEnter={generateSignUpOtp}
          />
          {errorMsg && <div className="error">{errorMsg}</div>}
        </div>
        {isShowOtp && (
          <>
            <span className="verification_text">
              Verification code sent to your email id
            </span>
            <div className="user_otp">
              <Input
                name="otp"
                onChange={handleChange}
                placeholder="Verification Code"
                required
                className="otp_input"
                value={formData?.otp}
                onPressEnter={verifyOtp}
              />
              {isOtpVerified && (
                <div className="verified">
                  <p>
                    Verified <img src={verifyIcon} alt="" />
                  </p>
                </div>
              )}
            </div>
          </>
        )}
        {isShowPassword && (
          <div className="user_password">
            <Input.Password
              placeholder="Enter Password"
              required
              name="password_input"
              className="password_input"
              type="password"
              onChange={handlePasswordChange}
              onPressEnter={registerUser}
            />
            {errorPassword && <div className="error">{errorPassword}</div>}
          </div>
        )}
        <div className="continue_btn_line">
          <Button
            className={`continue_btn ${isButtoDisable ? 'disable_btn' : ''}`}
            disabled={isButtoDisable}
            onClick={
              isShowOtp
                ? verifyOtp
                : isShowPassword
                  ? registerUser
                  : generateSignUpOtp
            }
          >
            <p> Continue </p>
            {loading && (
              <div className="spinner">
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{
                        fontSize: 24,
                        color: 'white',
                        marginLeft: '20px',
                      }}
                      spin
                    />
                  }
                />
              </div>
            )}
          </Button>
        </div>
      </>
    );
  };
  return (
    <div className="sigup_wrapper">
      <div className="direction">
        {/* {getMetaModelLogo()} */}
        <div className="direction_line_1">Create your account</div>
        <div className="direction_line_2">Sign up to continue</div>
        {getGoogleLogin()}
        <div className="direction_line_3">
          Or sign up using your email address
        </div>
        {getUserRegistrationForm()}
      </div>
      <div className="direction_line_4">
        Already have an account? <Link to="/login">Log in</Link>
      </div>
    </div>
  );
};

export default SignUp;
